import React from 'react';
import { Trophy, Target, Zap, Users } from 'lucide-react';

const features = [
  {
    icon: Trophy,
    title: 'Sport-Specific Names',
    description: 'Names tailored for each sport, from football to hockey.'
  },
  {
    icon: Target,
    title: 'Multiple Levels',
    description: 'Options for professional, amateur, youth, and college teams.'
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'Get unique team names in seconds with our AI generator.'
  },
  {
    icon: Users,
    title: 'Team Identity',
    description: 'Names that build team spirit and unity.'
  }
];

export default function SportsTeamFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Why Choose Our Sports Team Name Generator?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg border border-indigo-200 hover:shadow-lg transition-shadow">
              <feature.icon className="w-12 h-12 text-indigo-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}